/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgObjectIc = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M19 2a3 3 0 0 0-2.704 4.301L14.597 8H9.403l-1.7-1.699a3 3 0 1 0-1.418 1.41L8 9.426v5.148L6.286 16.29a3 3 0 1 0 1.418 1.41L9.403 16h1.45v-2H10v-4h4v1.276h2v-1.85l1.714-1.715A3 3 0 1 0 19 2zm-1 3a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM4 5a1 1 0 1 1 2 0 1 1 0 0 1-2 0zm0 14a1 1 0 1 1 2 0 1 1 0 0 1-2 0zm18.834 1.092v1.56a5.637 5.637 0 0 1-1.092.36 5.49 5.49 0 0 1-1.356.156c-1.4 0-2.46-.396-3.18-1.188-.72-.8-1.08-1.948-1.08-3.444 0-.92.176-1.708.528-2.364a3.627 3.627 0 0 1 1.5-1.524c.648-.36 1.42-.54 2.316-.54.424 0 .816.044 1.176.132s.676.2.948.336v1.584a7.448 7.448 0 0 0-1.104-.336 4.305 4.305 0 0 0-.888-.096c-.824 0-1.456.244-1.896.732s-.66 1.18-.66 2.076c0 .968.216 1.716.648 2.244.432.52 1.068.78 1.908.78.336 0 .676-.036 1.02-.108.352-.08.756-.2 1.212-.36z" />
        <path d="M12.852 22v-8.724h1.872V22z" />
      </g>
    </g>
  </Icon>
);
export { SvgObjectIc as ObjectIc };
